/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconNavigationProjobs = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 21 23"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="1.414"
  >
    <path
      d="M13.446 7c.265 2.579.783 7.618.783 7.667a.483.483 0 0 1-.502.483H2.542a.485.485 0 0 1-.48-.531l.916-9.151C3.137 4.102 4.013 3 5.287 3H8v2.997A.994.994 0 0 0 8.999 7h4.447zm2.314 3.6a.507.507 0 0 0-.508.508v4.942H1.017v-4.942a.508.508 0 0 0-1.017 0v6.101c0 .562.455.875 1.017.875h5.084v2.263L.898 21.931a.509.509 0 0 0 .295.973l6.939-2.112 6.997 2.185a.509.509 0 0 0 .303-.971l-5.264-1.644v-2.278h5.084c.562 0 1.016-.313 1.016-.875v-6.101a.507.507 0 0 0-.508-.508z"
      fill="currentColor"
    />
    <path
      d="M21 1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V1z"
      fill="#cfdc00"
    />
    <g fill="#333" fillRule="nonzero">
      <path d="M11.425 1.545h-1.02V5h.66V3.795h.405c.78 0 1.355-.355 1.355-1.15 0-.745-.53-1.1-1.4-1.1zM11.42 3.3h-.355V2.03h.355c.45 0 .715.18.715.615 0 .505-.275.655-.715.655zM15.205 5h.76l-.905-1.505c.47-.185.7-.46.7-.935 0-.685-.465-1.015-1.37-1.015h-1.03V5h.66V3.615h.42L15.205 5zM14.02 2.025h.355c.48 0 .695.16.695.535 0 .415-.23.58-.64.58h-.41V2.025zM17.69 1.47c-.925 0-1.515.67-1.515 1.805 0 1.155.59 1.8 1.515 1.8.925 0 1.51-.665 1.51-1.805 0-1.155-.585-1.8-1.51-1.8zm0 .505c.52 0 .815.37.815 1.295 0 .935-.3 1.3-.815 1.3-.505 0-.82-.365-.82-1.295 0-.93.305-1.3.82-1.3z" />
    </g>
  </svg>
);

IconNavigationProjobs.displayName = 'IconNavigationProjobs';

IconNavigationProjobs.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconNavigationProjobs);
IconNavigationProjobs.displayName = 'IconNavigationProjobs';
